import React from 'react';
import './content-list-feed.css';

export default function ContentListFeedSection({ heading, ariaLabel, children }) {
  return (
    <section className="content-list-feed-section" aria-label={ariaLabel}>
      {heading ? (
        <h2 className="content-list-feed-heading">{heading}</h2>
      ) : null}
      {children}
    </section>
  );
}
